import { Controller } from "@hotwired/stimulus";
import { parseWallClock, weekdayBefore, formatWallClock } from "../utils/wallClock";

// GR-4097: on the template schedule form, shows either the fixed-offset or the
// weekday-of-the-week-before close controls, and keeps the worked example for
// the weekday rule in step with them. Each set sits in a fieldset that is
// disabled while hidden, so its required inputs do not block the submit.
//
// The example mirrors Event::RegistrationCloseRule, which is what applies the
// rule; a drift between the two is cosmetic. It is wall-clock arithmetic, so
// the browser's zone does not move it.
export default class extends Controller {
  static targets = ["offset", "rule", "weekday", "weeksBefore", "time", "example"];
  static values = { exampleStart: String };

  toggle(event) {
    const weekday = event.target.value === "weekday";

    this.offsetTarget.hidden = weekday;
    this.offsetTarget.disabled = weekday;
    this.ruleTarget.hidden = !weekday;
    this.ruleTarget.disabled = !weekday;
  }

  describe() {
    const start = parseWallClock(this.exampleStartValue);
    const weekday = Number(this.weekdayTarget.value);
    const weeksBefore = Number(this.weeksBeforeTarget.value);
    const time = this.timeTarget.value;

    if (!start || !(weekday >= 1 && weekday <= 7) || !(weeksBefore >= 1) || !/^\d{2}:\d{2}$/.test(time)) {
      this.exampleTarget.textContent = "Enter a weekday, a number of weeks and a time to see an example.";
      return;
    }

    const closes = weekdayBefore(start, { weekday, weeks_before: weeksBefore, time });
    this.exampleTarget.textContent =
      `For example, an event starting ${formatWallClock(start)} closes registration ${formatWallClock(closes)} at ${time}.`;
  }
}
